import React from 'react';
import { CheckIcon } from 'lucide-react';
import { CtaButton } from './CtaButton';
export function BenefitsSection() {
  return <section className="bg-[#faf6f0] text-gray-900 py-20 px-4" data-id="element-22">
      <div className="max-w-4xl mx-auto" data-id="element-23">
        <h2 className="font-oswald text-4xl md:text-5xl font-bold text-center mb-12 uppercase tracking-tight text-[#2a1f14]" data-id="element-24">
          Después de aplicar estas enseñanzas podrás:
        </h2>

        <div className="bg-white p-8 md:p-12 rounded-2xl shadow-xl border border-gray-200 max-w-3xl mx-auto mb-12" data-id="element-25">
          <ul className="space-y-6" data-id="element-26">
            {['Reducir el sobrepensamiento', 'Sentir mayor calma mental', 'Tomar decisiones con más claridad', 'Manejar mejor el estrés', 'Vivir con una mente más tranquila'].map((item, i) => <li key={i} className="flex items-center gap-4" data-id="element-27">
                <div className="bg-[#7a9e7a]/15 p-2 rounded-full flex-shrink-0" data-id="element-28">
                  <CheckIcon className="w-6 h-6 text-[#7a9e7a] font-bold" data-id="element-29" />
                </div>
                <span className="font-opensans text-xl md:text-2xl font-bold text-gray-800" data-id="element-30">
                  {item}
                </span>
              </li>)}
          </ul>
        </div>

        <div className="text-center mb-12" data-id="element-31">
          <p className="font-opensans text-2xl md:text-3xl text-gray-700 italic font-semibold leading-relaxed px-4" data-id="element-32">
            "Imagina cómo sería tu vida si tu mente dejara de luchar
            constantemente."
          </p>
        </div>

        <div className="text-center" data-id="element-33">
          <CtaButton text="QUIERO CALMAR MI MENTE AHORA" data-id="element-34" />
        </div>
      </div>
    </section>;
}